module.exports = __webpack_public_path__ + "img/location-pin.b1d23557.png";